import type { IntakeQuestion } from "../../registry/types";

export const SHOPPER_AGENT_INTAKE_QUESTIONS: IntakeQuestion[] = [
  {
    id: "onboarding-goal",
    prompt: "What do you want Concierge to help you launch first?",
    required: true,
    type: "single-select",
    options: [
      { value: "support", label: "Support conversations" },
      { value: "sales", label: "Sales and conversion" },
      { value: "retention", label: "Retention and follow-up" },
    ],
  },
];
